const applyParameters = (translation, parameters) => translation.replace(/%[^%]+%/g, (match) => {
    const parameter = match.replace(/%/g, '');

    return parameters[parameter] ?? match;
});

export const isShowTranslationKeysRequested = config => (config?.location ?? window.location.href).indexOf('show_keys=1') > -1;

export const getTranslation = (key, parameters, translations) => {
    const translation = translations ? translations[key] : null;

    if (translation) {
        return typeof parameters === 'object' && parameters !== null
            ? applyParameters(translation, parameters)
            : translation;
    }

    return key;
};
